import type { ServiceRecord } from '../../../types'
import { CreateServiceCard } from './CreateServiceCard'
import { ServiceCard } from './ServiceCard'

type ServicesGridProps = {
  services: ServiceRecord[]
  onToggleActive: (id: string) => void
  onEdit: (id: string) => void
  onView: (id: string) => void
  onCreate: () => void
  updatingIds: Set<string>
}

export const ServicesGrid = ({
  services,
  onToggleActive,
  onEdit,
  onView,
  onCreate,
  updatingIds,
}: ServicesGridProps) => {
  if (services.length === 0) {
    return (
      <div className="flex flex-col items-center gap-[25px]">
        <p className="w-full py-[40px] text-center font-host text-[16px] font-normal leading-normal text-dash-col-head">
          No services match the selected category.
        </p>
        <CreateServiceCard onCreate={onCreate} />
      </div>
    )
  }

  const firstRow = services.slice(0, 4)
  const secondRow = services.slice(4)

  return (
    <div className="flex flex-col gap-[25px]">
      <div className="flex flex-wrap items-stretch gap-[24px]">
        {firstRow.map((service) => (
          <ServiceCard
            key={service.id}
            onEdit={onEdit}
            onToggleActive={onToggleActive}
            onView={onView}
            isUpdating={updatingIds.has(service.id)}
            service={service}
          />
        ))}
      </div>

      {(secondRow.length > 0 || services.length <= 4) && (
        <div className="flex flex-wrap items-stretch gap-[24px]">
          {secondRow.map((service) => (
            <ServiceCard
              key={service.id}
              onEdit={onEdit}
              onToggleActive={onToggleActive}
              onView={onView}
              isUpdating={updatingIds.has(service.id)}
              service={service}
            />
          ))}
          <CreateServiceCard onCreate={onCreate} />
        </div>
      )}
    </div>
  )
}
